import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import { Progress } from 'antd';
import { formatPercentage } from 'utils/number';
import { useMemo } from 'react';
import { InfoTable } from '../DetailModal/InfoTable';

export interface IPortfolioAllocation {
  equity?: number;
  unrealisedMarketValue?: number;
}

const PortfolioAllocation = ({
  equity,
  unrealisedMarketValue,
}: IPortfolioAllocation) => {
  const allocationPercentage = useMemo(
    () => (unrealisedMarketValue / equity) * 100,
    [unrealisedMarketValue, equity],
  );

  return (
    <InfoTable
      dataSource={[
        {
          label: <Text>Portfolio Allocation</Text>,
          value: (
            <Flex align="center" as="p">
              <Progress
                width={20}
                strokeWidth={16}
                trailColor="#EDEDED"
                percent={allocationPercentage}
                type="circle"
                showInfo={false}
              />
              {/* @ts-expect-error */}
              <Text ml="5px" family="bold">
                {formatPercentage(allocationPercentage, true, '0.00', true)}
              </Text>
            </Flex>
          ),
        },
      ]}
    />
  );
};

export default PortfolioAllocation;
